import React from "react"
import {Button} from "semantic-ui-react"
import PropTypes from "prop-types"
import ProductPriceInquiry from "components/Product/ProductPriceInquiry"
import shop from "shop/shop"

const ListActions = ( { list, product } ) => {
	const [ modaleOpen, setModaleOpen ] = React.useState( false )
	const priceInquiryOnly = !!(product.extras && product.extras.Preisanfrage && product.extras.Preisanfrage.value && product.extras.Preisanfrage.value.value === "J")

	return (
		<Button.Group className="pl2">
			<Button style={{border: "none", background: "none"}}
				icon="trash"
				onClick={() => {
					list.remove( product )
				}}
			/>
			{priceInquiryOnly ? <div style={{minWidth: "100px"}}>
				<Button style={{border: "none", background: "none", height: "auto", maxWidth: "100px"}}
					onClick={() => setModaleOpen( !modaleOpen )}
				>{translate( "Preis" )}<br/>{translate( "anfragen" )}</Button></div>
				:
				<div><Button style={{border: "none", background: "none"}}
					icon="cart"
					onClick={() => {
						list.toCart( product )
						shop.toast( `${product.count * product.unit_multi} Stück ${product.title} ${translate( "im Warenkorb" )}`, "info", false, "bottom" )
					}}
				/></div>
			}
			{priceInquiryOnly && <ProductPriceInquiry product={product} modaleOpen={modaleOpen} onCloseModal={() => setModaleOpen( false )}/>}
		</Button.Group>
	)
}
export default ListActions

ListActions.propTypes = {
	list:    PropTypes.object,
	product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductRowListAction.js